var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"question-text",domProps:{"innerHTML":_vm._s(_vm.questionText)}}),_c('button',{staticClass:"next active",on:{"click":_vm.next}},[_vm._v("Next")])])}
var staticRenderFns = []

export { render, staticRenderFns }